module.exports = __webpack_public_path__ + "static/media/BoxPlotQ3_5.25f7eb9c.svg";